export default __webpack_public_path__ + "locales/sr-Latn-RS/PDFFormDialog.json?hash=6e07d99058911e63431f0c8daaf39de8";